(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/core-js/map', 'babel-runtime/regenerator', 'babel-runtime/helpers/toConsumableArray', 'babel-runtime/helpers/slicedToArray', './consts', './parser.utils', './utils', '../util/lang'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/map'), require('babel-runtime/regenerator'), require('babel-runtime/helpers/toConsumableArray'), require('babel-runtime/helpers/slicedToArray'), require('./consts'), require('./parser.utils'), require('./utils'), require('../util/lang'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.map, global.regenerator, global.toConsumableArray, global.slicedToArray, global.consts, global.parser, global.utils, global.lang);
    global.toPath = mod.exports;
  }
})(this, function (exports, _map, _regenerator, _toConsumableArray2, _slicedToArray2, _consts, _parser, _utils, _lang) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.toPath = undefined;

  var _map2 = _interopRequireDefault(_map);

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

  var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _marked = _regenerator2.default.mark(extractListProps);

  /**
   * Strip slashes preceding occurences of <code>quote</code> from <code>str</code><br />
   * Possible quotes are <code>"</code> and <code>'</code>.
   * @function
   * @param {string} str The string
   * @param {string} quote The quote to unescape
   * @returns {string} The unescaped string
   * @memberof path
   * @private
   * @since 1.0.0
   */
  var unescapeQuotes = function unescapeQuotes(str, quote) {
    return str.replace(new RegExp('\\\\' + quote, 'g'), quote);
  };

  /**
   * Converts <code>str</code> to a slice index.
   * @function
   * @param {string} str The string to convert
   * @param {number?} defaultValue The default value if <code>str</code> is empty
   * @returns {number} <code>undefined</code> if <code>str</code> is empty, otherwise an int (may be NaN)
   * @memberof path
   * @private
   * @since 1.0.0
   */
  var toSliceIndex = function toSliceIndex(str, defaultValue) {
    return str === '' ? defaultValue : Number(str);
  };

  /**
   * Tests whether <code>arg</code> is a valid slice index once converted to a number.
   * @function
   * @memberof path
   * @param {*} arg The value to test
   * @returns {boolean} True if <code>arg</code> is a valid slice index once converted to a number, false otherwise.
   * @private
   * @since 1.0.0
   */
  var isSliceIndexString = function isSliceIndexString(arg) {
    return (0, _utils.isSliceIndex)(arg ? Number(arg) : undefined);
  };

  var emptyStringParser = function emptyStringParser(str) {
    return str.length === 0 ? [] : null;
  };

  var quotedBracketNotationParser = (0, _parser.map)((0, _parser.regexp)(/^\[(['"])(.*?[^\\])\1\]?\.?(.*)$/), function (_ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 3),
        quote = _ref2[0],
        property = _ref2[1],
        rest = _ref2[2];

    return [[_consts.prop, unescapeQuotes(property, quote)]].concat((0, _toConsumableArray3.default)(applyParsers(rest)));
  });

  var incompleteQuotedBracketNotationParser = (0, _parser.map)((0, _parser.regexp)(/^(\[["'][^.[{]*)\.?(.*)$/), function (_ref3) {
    var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
        beforeNewSegment = _ref4[0],
        rest = _ref4[1];

    return [[_consts.prop, beforeNewSegment]].concat((0, _toConsumableArray3.default)(applyParsers(rest)));
  });

  var bareBracketNotationParser = (0, _parser.map)((0, _parser.regexp)(/^\[([^\]]*)\]\.?(.*)$/), function (_ref5) {
    var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
        property = _ref6[0],
        rest = _ref6[1];

    return (0, _utils.isIndex)(Number(property)) ? [[_consts.index, Number(property)]].concat((0, _toConsumableArray3.default)(applyParsers(rest))) : [[_consts.prop, property]].concat((0, _toConsumableArray3.default)(applyParsers(rest)));
  });

  var incompleteBareBracketNotationParser = (0, _parser.map)((0, _parser.regexp)(/^(\[[^.[{]*)\.?(.*)$/), function (_ref7) {
    var _ref8 = (0, _slicedToArray3.default)(_ref7, 2),
        beforeNewSegment = _ref8[0],
        rest = _ref8[1];

    return [[_consts.prop, beforeNewSegment]].concat((0, _toConsumableArray3.default)(applyParsers(rest)));
  });

  var sliceNotationParser = (0, _parser.map)((0, _parser.filter)((0, _parser.regexp)(/^\[([^:\]]*):([^:\]]*)\]\.?(.*)$/), function (_ref9) {
    var _ref10 = (0, _slicedToArray3.default)(_ref9, 2),
        sliceStart = _ref10[0],
        sliceEnd = _ref10[1];

    return isSliceIndexString(sliceStart) && isSliceIndexString(sliceEnd);
  }), function (_ref11) {
    var _ref12 = (0, _slicedToArray3.default)(_ref11, 3),
        sliceStart = _ref12[0],
        sliceEnd = _ref12[1],
        rest = _ref12[2];

    return [[_consts.slice, [toSliceIndex(sliceStart, 0), toSliceIndex(sliceEnd)]]].concat((0, _toConsumableArray3.default)(applyParsers(rest)));
  });

  var listWildCardParser = (0, _parser.map)((0, _parser.regexp)(/^{\*}\.?(.*)$/), function (_ref13) {
    var _ref14 = (0, _slicedToArray3.default)(_ref13, 1),
        rest = _ref14[0];

    return [[_consts.allProps]].concat((0, _toConsumableArray3.default)(applyParsers(rest)));
  });

  var listPropRegexp = /^,?((?!["'])([^,]*)|(["'])(.*?[^\\])\3)(.*)/;
  function extractListProps(rawProps) {
    var remProps, _listPropRegexp$exec, _listPropRegexp$exec2, bareProp, quotedProp, rest;

    return _regenerator2.default.wrap(function extractListProps$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!rawProps.startsWith(',')) {
              _context.next = 3;
              break;
            }

            _context.next = 3;
            return '';

          case 3:
            remProps = rawProps;

          case 4:
            if (!(remProps !== '')) {
              _context.next = 11;
              break;
            }

            _listPropRegexp$exec = listPropRegexp.exec(remProps), _listPropRegexp$exec2 = (0, _slicedToArray3.default)(_listPropRegexp$exec, 6), bareProp = _listPropRegexp$exec2[2], quotedProp = _listPropRegexp$exec2[4], rest = _listPropRegexp$exec2[5];
            _context.next = 8;
            return bareProp === undefined ? quotedProp : bareProp;

          case 8:
            remProps = rest;
            _context.next = 4;
            break;

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked, this);
  }

  var listNotationParser = (0, _parser.map)((0, _parser.regexp)(/^\{(((?!["'])[^,}]*|(["']).*?[^\\]\2)(,((?!["'])[^,}]*|(["']).*?[^\\]\6))*)\}\.?(.*)$/), function (_ref15) {
    var _ref16 = (0, _slicedToArray3.default)(_ref15, 7),
        rawProps = _ref16[0],
        rest = _ref16[6];

    var props = [].concat((0, _toConsumableArray3.default)(extractListProps(rawProps)));
    return props.length === 1 ? [[_consts.prop, props[0]]].concat((0, _toConsumableArray3.default)(applyParsers(rest))) : [[_consts.list, props]].concat((0, _toConsumableArray3.default)(applyParsers(rest)));
  });

  var incompleteListNotationParser = (0, _parser.map)((0, _parser.regexp)(/^(\{[^.[{]*)\.?(.*)$/), function (_ref17) {
    var _ref18 = (0, _slicedToArray3.default)(_ref17, 2),
        beforeNewSegment = _ref18[0],
        rest = _ref18[1];

    return [[_consts.prop, beforeNewSegment]].concat((0, _toConsumableArray3.default)(applyParsers(rest)));
  });

  var pathSegmentEndedByNewSegment = (0, _parser.map)((0, _parser.regexp)(/^([^.[{]*)\.?([[{]?.*)$/), function (_ref19) {
    var _ref20 = (0, _slicedToArray3.default)(_ref19, 2),
        beforeNewSegment = _ref20[0],
        rest = _ref20[1];

    return [[_consts.prop, beforeNewSegment]].concat((0, _toConsumableArray3.default)(applyParsers(rest)));
  });

  var applyParsers = (0, _parser.race)([emptyStringParser, quotedBracketNotationParser, incompleteQuotedBracketNotationParser, sliceNotationParser, bareBracketNotationParser, incompleteBareBracketNotationParser, listWildCardParser, listNotationParser, incompleteListNotationParser, pathSegmentEndedByNewSegment]);

  var MAX_CACHE_SIZE = 1000;
  var cache = new _map2.default();

  var stringToPath = function stringToPath(pStr) {
    var str = pStr.startsWith('.') ? pStr.substring(1) : pStr;

    var path = applyParsers(str);

    return pStr.endsWith('.') ? [].concat((0, _toConsumableArray3.default)(path), [[_consts.prop, '']]) : path;
  };

  /**
   * Memoized version of {@link path.stringToPath}.<br />
   * The cache has a maximum size of 1000, when overflowing the cache is cleared.
   * @function
   * @param {string} str The string to convert
   * @returns {Array<Array<Symbol,*>>} The path represented as an array of keys
   * @memberof path
   * @private
   * @since 1.0.0
   */
  var memoizedStringToPath = function memoizedStringToPath(str) {
    if (cache.has(str)) return cache.get(str);

    var path = stringToPath(str);

    if (cache.size === MAX_CACHE_SIZE) cache.clear();
    cache.set(str, path);

    return path;
  };

  /**
   * Converts <code>arg</code> to a path represented as an array of keys.<br />
   * <code>arg</code> may be a string, in which case it will be parsed.<br />
   * It may also be an Array, in which case a copy of the array with values converted to path keys will be returned.<br />
   * If <code>arg</code> is neither a string nor an Array, its string representation will be parsed.
   * @function
   * @param {string|Array|*} arg The value to convert
   * @returns {Array<Array<Symbol,*>>} The path represented as an array of keys
   * @memberof path
   * @since 1.0.0
   * @example toPath('a.b[1]["."][1:-1]') // => [[prop, 'a'], [prop, 'b'], [index, 1], [prop, '.'], [slice, [1, -1]]]
   * @private
   */
  var toPath = function toPath(arg) {
    if ((0, _lang.isNil)(arg)) return [];

    return memoizedStringToPath((0, _lang.toString)(arg));
  };

  exports.toPath = toPath;
});